import axios from "axios";
import { stationStatusesLookupSlice } from "../../slice/stations/getStationStatusLookupSlice";
import apiHeader from "../../../Components/ApiHeader";

const { actions } = stationStatusesLookupSlice;

export const stationStatusesLookUpDropdownAPI: any =
  ({ ApiUrl, Type, params }: any) =>
  (dispatch: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    axios
      .get(ApiUrl, {
        params: params,
        // headers: {
        //   istoken: "false",
        // },
        headers: commonHead,
      })
      .then((response) => {
        const { data } = response;
        dispatch(actions.getStationStatusesData({ type: Type, data }));
      })
      .catch((err) => {
        dispatch(
          actions.getStationStatusesData({ type: "error", paylod: err.message })
        );
      });
  };
